import * as angular from "angular";

const resourceTypes = [
  'OnDutyAgents',
  'Allocation',
  "AgentSchedule"
];

const resourceAllocationActions = [
  {
    key: 'ATTACH_ALLOCATION',
    name: 'Add an allocation',
    icon: 'plus',
    permission: 'fleetManagement.allocations.create'
  },
  {
    key: 'DUPLICATE_RESOURCE',
    name: 'Duplicate resource',
    icon: 'duplicate',
    permission: 'fleetManagement.allocations.create'
  },
  {
    key: 'EDIT_RESOURCE',
    name: 'Edit resource',
    icon: 'edit-outline',
    permission: 'fleetManagement.allocations.update'
  },
  {
    key: 'ASSIGN_AGENT_TO_ALLOCATIONS',
    name: 'Assign agent to allocations',
    icon: 'assign',
    permission: 'fleetManagement.allocations.update'
  },
  {
    key: 'REMOVE_RESOURCE',
    name: 'Remove resource',
    icon: 'trash',
    permission: 'fleetManagement.allocations.delete'
  }
];

const allocationActionsByType = {
  ResourceAllocation: [
    {
      key: 'DUPLICATE_ALLOCATION',
      name: 'Duplicate allocation',
      icon: 'duplicate-outline',
      permission: 'fleetManagement.allocations.create'
    },
    {
      key: 'SETUP_ALLOCATION',
      name: 'Allocation setup',
      icon: 'location-pin',
      permission: 'fleetManagement.allocations.update'
    },
    {
      key: 'ASSIGN_AGENT',
      name: 'Assign an agent',
      icon: 'user-add',
      permission: 'fleetManagement.allocations.update'
    },
    {
      key: 'UNASSIGN_AGENT',
      name: 'Unassign an agent',
      icon: 'deactivate',
      permission: 'fleetManagement.allocations.update'
    },
    {
      key: 'REMOVE_ALLOCATION',
      name: 'Remove allocation',
      icon: 'trash',
      permission: 'fleetManagement.allocations.delete'
    }
  ],
  AgentSchedule: [
    {key: 'REMOVE_AGENT', name: 'Remove agent', icon: 'trash', permission: 'fleetManagement.allocations.delete'},
  ]
};

const serviceAreasPriorities = [
  {priorityName: 'Primary', value: 2},
  {priorityName: 'Secondary', value: 1}
];

angular
  .module('bringoz.admin.resources')
  .constant('resourcesConstants', {
    resourceTypes: resourceTypes,
    resourceAllocationActions: resourceAllocationActions,
    allocationActionsByType: allocationActionsByType,
    serviceAreasPriorities: serviceAreasPriorities
  });
